module.exports = __webpack_public_path__ + "static/media/gobmxlogo.eed1d59c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gobmxlogo.svg
// module id = 27
// module chunks = 0